// extracted by mini-css-extract-plugin
module.exports = {"articleQuote":"article-quote_articleQuote__1hcr-","quote":"article-quote_quote__2QqoT","authorName":"article-quote_authorName__1zLs3"};